import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const size = {
    mobile: 6,
    desktop: 8,
    padding: 8,
};

const UnorderedList = styled.ul<{ $color?: COLORS }>`
    list-style: none;
    margin: 0;
    padding: 0;

    & li {
        position: relative;
        padding-left: ${size.mobile + size.padding}px;
        padding-bottom: 4px;

        @media (min-width: ${wideBreakpoints.mobile}) {
            padding-left: ${size.desktop + size.padding}px;
        }
    }
    
    & li:last-child {
        padding-bottom: 0;
    }
    
    ${Paragraph4} {
        color: ${({ $color = COLORS.TextSecondary }) => $color};
    }

    & li::before {
        display: inline-block;
        content: '';

        width: ${size.mobile}px;
        height: ${size.mobile}px;
        background-color: ${COLORS.Brand_Blue};
        border-radius: 50%;
        margin-right: 8px;
    
        position: absolute;
        top: 0.5em;
        left: 0;

        @media (min-width: ${wideBreakpoints.mobile}) {
            width: ${size.desktop}px;
            height: ${size.desktop}px;
        }
    }
`;

export default UnorderedList;
